import * as React from "react";
import { Shield, Network, TrendingUp, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const features = [{
  title: "Audit-Ready Precision",
  description: "Our meticulous bookkeeping ensures your records are always compliant and ready for any financial review.",
  icon: Shield,
  iconColor: "text-secondary",
  link: "/OurServicesPage"
}, {
  title: "Cloud-Based Ecosystem",
  description: "Access your financial data anywhere with our secure, real-time digital infrastructure and node-network tools.",
  icon: Network,
  iconColor: "text-secondary",
  link: "/OurServicesPage"
}, {
  title: "Proactive Growth Insights",
  description: "We don't just report history; we provide the strategic guidance and cash-flow optimization you need to scale.",
  icon: TrendingUp,
  iconColor: "text-secondary",
  link: "/OurServicesPage"
}];
export default function TheLedgerAdvantage() {
  return <section data-section-id="225002" id="the-ledger-advantage" className="dark bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl">
            The Ledger Advantage
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground font-default">
            Precision modernism for your business finances. We combine fintech speed with the reliability of expert accounting.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {features.map((feature, i) => <div data-index={i} key={i} className="group relative h-full">
              <Link to={feature.link} className="absolute inset-0 z-10">
                <span className="sr-only">Learn more about {feature.title}</span>
              </Link>
              <Card className="flex h-full flex-col justify-between rounded-lg border border-border bg-card/50 backdrop-blur-md shadow-md transition-all duration-400 group-hover:-translate-y-1 group-hover:border-primary group-hover:shadow-[0_0_20px_rgba(158,64,52,0.15)]">
                <div>
                  <CardHeader className="pb-4">
                    <feature.icon className={`mb-4 size-16 stroke-[1.5] ${feature.iconColor}`} aria-hidden="true" />
                    <CardTitle className="font-default text-2xl font-bold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-muted-foreground font-mono">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </div>
                <div className="px-6 pb-6">
                  <div className="flex items-center text-sm font-bold text-primary opacity-0 transition-all duration-400 group-hover:translate-x-2 group-hover:opacity-100">
                    Explore Solution <ArrowRight className="ml-2 size-4 stroke-[3]" />
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}